import { lazy } from "react";

const Dashboard = lazy(() => import("../pages/Dashboard/Dashboard"));
const ProfileMain = lazy(() => import("../pages/Profile/ProfileMain"));
const ItemsMain = lazy(() => import("../pages/ItemLibrary/ItemsMain"));
const Login = lazy(() => import("../pages/Auth/Login"));
const Register = lazy(() => import("../pages/Auth/Register"));
const ForgotPassword = lazy(() => import("../pages/Auth/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/Auth/ResetPassword"));
const Item = lazy(() => import("../pages/ItemLibrary/Item"));
const LandingPage = lazy(() => import("../pages/LandingPage/LandingPage"));
const VerifyEmail = lazy(() => import("../pages/Auth/VerifyEmail"));
const ManualCosting = lazy(() => import("../pages/ItemLibrary/ManualCosting"));
const Referral = lazy(() => import("../pages/Referral/Referral"));
const Project = lazy(() => import("../pages/Projects/Project"));
const IndividualProject = lazy(
	() => import("../pages/Projects/IndividualProject"),
);
const DetailedCosting = lazy(
	() => import("../pages/ItemLibrary/DetailedCosting"),
);
const CostMaster = lazy(() => import("../pages/CostMaster/CostMaster"));
const Credits = lazy(() => import("../pages/Credits/Credits"));
const SetupWorkspace = lazy(() => import("../pages/Auth/SetupWorkspace"));

const RoutesList: Array<{
	label: string;
	link: string;
	type: "public" | "private" | "landing" | "onboarding";
	component: typeof Dashboard;
}> = [
	//access pages
	{
		label: "Landing",
		link: "/",
		type: "landing",
		component: LandingPage,
	},
	{
		label: "Login",
		link: "/login/:redirect?",
		type: "public",
		component: Login,
	},
	{
		label: "Register",
		link: "/register/:customer_id?",
		type: "public",
		component: Register,
	},
	{
		label: "Register",
		link: "/verifyEmail/:email/:otpuuid?",
		type: "public",
		component: VerifyEmail,
	},
	{
		label: "Setup Workspace",
		link: "/setup-workspace",
		type: "onboarding",
		component: SetupWorkspace,
	},
	{
		label: "ForgotPassword",
		link: "/forgotPassword",
		type: "public",
		component: ForgotPassword,
	},
	{
		label: "ResetPassword",
		link: "/resetPassword/:changePasswordKey",
		type: "public",
		component: ResetPassword,
	},
	{
		label: "Dashboard",
		link: "/fileupload",
		type: "private",
		component: Dashboard,
	},
	{
		label: "ItemsLibrary",
		link: "/itemlibrary/",
		type: "private",
		component: ItemsMain,
	},
	{
		label: "ProfileMain",
		link: "/myprofile/:tab?",
		type: "private",
		component: ProfileMain,
	},
	{
		label: "ItemDetailsAce",
		link: "/itemlibrary/item/:itemid?/:showDFM?",
		type: "private",
		component: Item,
	},
	{
		label: "ItemDetailsManualCosting",
		link: "/itemlibrary/item/:itemid?/manualCosting",
		type: "private",
		component: ManualCosting,
	},
	{
		label: "Detailed Costing",
		link: "/itemlibrary/item/:itemid?/detailedCosting/:tab?",
		type: "private",
		component: DetailedCosting,
	},
	{
		label: "Cost Master",
		link: "/costMaster/:section?/:category?",
		type: "private",
		component: CostMaster,
	},
	{
		label: "Referral",
		link: "/myprofile/referral",
		type: "private",
		component: Referral,
	},
	{
		label: "Credits",
		link: "/credits",
		type: "private",
		component: Credits,
	},
	{
		label: "Projects",
		link: "/projects",
		type: "private",
		component: Project,
	},
	{
		label: "Project",
		link: "/projects/project/:id/:name?",
		type: "private",
		component: IndividualProject,
	},
];

export default RoutesList;
